import { useUX } from '@/ux'
import { Locale } from '@/ux/types'

export function LanguageToggle() {
  const { locale, setLocale } = useUX()

  const languages: { value: Locale; label: string; icon: string }[] = [
    { value: 'en', label: 'English', icon: '🇬🇧' },
    { value: 'fr', label: 'Français', icon: '🇫🇷' },
  ]

  return (
    <div
      className="flex gap-1 bg-gray-100 dark:bg-gray-800 rounded-lg p-1"
      role="group"
      aria-label="Language switcher"
    >
      {languages.map(({ value, label, icon }) => (
        <button
          key={value}
          type="button"
          onClick={() => setLocale(value)}
          className={`px-2 py-1 text-sm rounded transition ${
            locale === value
              ? 'bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 shadow-sm'
              : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-100'
          }`}
          aria-label={`Switch to ${label}`}
          aria-pressed={locale === value}
          title={label}
        >
          <span className="text-base" aria-hidden="true">
            {icon}
          </span>
          <span className="sr-only">{label}</span>
        </button>
      ))}
    </div>
  )
}
